module.exports = __webpack_public_path__ + "static/media/body2.37e4a605.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/body2.png
// module id = 1642
// module chunks = 0